<template>
  <div>
    <Head title="Create Mail Template" />
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><Link href="/settings">Settings</Link></li>
        <li class="breadcrumb-item"><Link href="/settings/mail/inserts">Mail Inserts</Link></li>
        <li class="breadcrumb-item active" aria-current="page">Edit Mail Insert</li>
      </ol>
    </nav>
    <h1>Edit Mail Insert</h1>

    <div class="content-box">
      <form @submit.prevent="update">
        <MailInsertForm :form="form" />

        <div class="actions-toolbar">
          <loading-button :loading="form.processing" class="btn btn-primary" type="submit">Update Insert</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import MailInsertForm from './components/MailInsertForm'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  components: {
    Head,
    Icon,
    Link,
    MailInsertForm,
    LoadingButton,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    mailtemplates: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name: this.mailtemplates.name,
        group: this.mailtemplates.group,
        sort: this.mailtemplates.sort,
        html_template: this.mailtemplates.html_template,
      }),
    }
  },
  methods: {
    update() {
      this.form.put(`/settings/mail/inserts/${this.mailtemplates.id}`)
    },
    destroy() {
      if (confirm('Are you sure you want to delete this mail insert?')) {
        this.$inertia.delete(`/settings/mail/inserts/${this.mailtemplates.id}`)
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this mail insert?')) {
        this.$inertia.put(`/settings/mail/inserts/${this.mailtemplates.id}/restore`)
      }
    },
  },
}
</script>
